<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-4">
            <button v-on:click="onCreate()" class="btn btn-primary">Register</button>
          </div>
          <div class="col-md-8">
            <div class="row" style="margin-right:0px;margin-bottom:5px;">
              <div class="col-md-5">
                <div class="form-inline pull-right">
                  <label for="pagesize">Show</label>                    
                  <select id="pagesize" @change="changePageSize" ref="recordPerPage" class="form-control" style="margin-left:5px; margin-right:10px;">
                    <option>5</option>
                    <option>10</option>
                    <option>20</option>
                    <option>50</option>
                    <option>100</option>
                  </select>              
                </div>
              </div>               
              <div class="col-md-7 has-feedback">
                <div class="row">                  
                  <input type="text" class="form-control" v-model="keyWords"  v-on:keyup.enter="onSearch($event)" placeholder="Search guest by name or email address or phone number">
                  <span class="icon ion-search form-control-feedback"></span>                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row center-block">      
      <div class="col-md-12">
        <div v-for="(row, i) in listData" v-bind:key="i">
          <div class="col-md-4">
            <div class="box box-widget widget-user">
              <!-- Add the bg color to the header using any of the bg-* classes -->
              <div class="widget-user-header bg-yellow">
                <h3 class="widget-user-username">{{ row.firstName + ' ' + row.lastName}}</h3>
                <h5 class="widget-user-desc">{{ row.emailAddress}}</h5>
              </div>
              <div class="widget-user-image">
                <img class="img-circle" style="max-height: 90px;max-width:90px;" :src="'/image/Guest/' + row.imageUrl + '?' + Date.now()" alt="Guest Avatar">
                <!-- <img class="img-circle" style="max-height: 90px;" :src="getImageUrl(row.id)" alt="Guest Avatar"> -->
              </div>
              <div class="box-footer">
                <div class="row">
                  <div class="col-xs-12">
                    <b v-if="row.isMember" style="font-size:1.5rem;color:blue!important">{{ row.memberNo }}</b>
                    <a href="#" v-if="!row.isMember" v-on:click="onCreateMember(row.id)"><b style="font-size:1.5rem;color:#3ac47d!important">Non Member</b></a>                                      
                    <button v-on:click="onCheckInOut(row)" class="btn btn-sm btn-success pull-right">CheckIn/Out</button>
                    <button v-on:click="onDisplay(row)" class="btn btn-sm btn-success pull-right" style="margin-right: 5px;">Detail</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row center-block">
      <div class="col-md-12">
        <div class="row pull-right">
          <div class="form-group">
            <label style="width:25px;text-align:right;">
                <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
            </label>
            <label style="width:35px;text-align:center;">
                <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
            </label>
            <label>
                Page
            </label>
            <label>
                <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" type="text" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
            </label>
            <label id="TotalPageText">
              {{ totalPages }}                
            </label>
            <label style="width:35px;text-align:center;">
                <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
            </label>
            <label style="width:25px;text-align:left;">
                <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
            </label>
          </div>
        </div> 
      </div>
    </div>

    <div class="modal fade" id="modal-checkinout" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">Check-In/Out Processing</h4>
          </div>
          <div class="modal-body">
            <div class="box no-border">
              <div class="form-group">
                <label>Project</label>
                <div>
                  <select v-model="projectCheckInOut" class="form-control">
                    <option v-for="(row, i) in listProject" v-bind:key="i" v-bind:value="{ id: row.id, text: row.name }">
                      {{ row.name }}
                    </option>
                  </select>
                </div>
              </div>                           
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Cancel</button>
            <button type="button" class="btn btn-primary" @click="onContinueCheckInOut($event)">Continue</button>
          </div>
        </div>
      </div>
    </div>     
    <div class="modal fade" id="modal-checkin" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">Check-In Processing</h4>
          </div>
          <div class="modal-body">
            <div class="box no-border">
              <div class="form-group">
                <label>Membership</label>
                <div>
                  <select v-model="guestMembershipCheckInOut" class="form-control">
                    <option v-for="(row, i) in listGuestMembership" v-bind:key="i" v-bind:value="{ id: row.membershipId, text: row.membershipName }">
                      {{ row.membershipName }}
                    </option>
                  </select>
                </div>
              </div>                           
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Cancel</button>
            <button type="button" class="btn btn-primary" @click="onContinueCheckIn($event)">Continue</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modal-checkout" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">Check-Out Processing</h4>
          </div>
          <div class="modal-body">
            <div class="box no-border">
              <div class="form-group">
                <label>Membership</label>
                <div>
                  <select v-model="guestMembershipCheckInOut" class="form-control">
                    <option v-for="(row, i) in listGuestMembership" v-bind:key="i" v-bind:value="{ id: row.membershipId, text: row.membershipName }">
                      {{ row.membershipName }}
                    </option>
                  </select>
                </div>
              </div>                           
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Cancel</button>
            <button type="button" class="btn btn-primary" @click="onContinueCheckOut($event)">Continue</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api'
import SweetAlert from 'sweetalert2'
import config from '../../config'

const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'

export default {
  name: 'Guest',
  components: {
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      DATE_FORMAT_SQL: config.dateFormatSql,
      DATETIME_FORMAT_ISO: config.dateTimeFormatSql,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      currentStatus: null,
      item: null,
      listData: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      keyWords: '',
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'FirstName'
      },
      viewMode: MODE_NONE,
      listProject: null,
      projectCheckInOut: null,
      guestCheckInOut: null,
      listGuestMembership: null,
      guestMembershipCheckInOut: null
    }
  },
  computed: {
  },
  created() {
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
    this.inquiry()
  },
  methods: {
    onCreate() {
      let params = {
        id: 0,
        mode: MODE_CREATE,
        callback: this.$route.name
      }
      this.$router.push({ name: 'Guest Form', params: params })
    },
    onDisplay(row) {
      let params = {
        id: row.id,
        mode: MODE_VIEW,
        callback: this.$route.name
      }
      this.$router.push({ name: 'Guest Form', params: params })
    },
    inquiry() {
      api
        .request('Guest', 'get', '/api/Guest/Inquiry?WhereClause=' + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    onSearch(evt) {
      var keyWords = evt.target.value
      var whereClause = ['FirstName', 'like', '\'%' + keyWords + '%\'']
      this.inquiryParam.WhereClause = whereClause.join(' ')
      whereClause = ['EmailAddress', 'like', '\'%' + keyWords + '%\'']
      this.inquiryParam.WhereClause = this.inquiryParam.WhereClause + ' OR ' + whereClause.join(' ')
      this.inquiry()
    },
    onCreateMember(id) {
      SweetAlert.fire({
        title: 'Are you sure to create member for this guest ?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Continue',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          var res = this.createMember(id)
          SweetAlert.fire('Member Creation', res.message, res.status)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          SweetAlert.fire('Cancelled', 'Member creation was cancelled', 'info')
        }
      })
    },
    createMember(id) {
      var status = ''
      var message = ''

      var reqData = {
        Id: id
      }
      api.request('Guest', 'post', '/api/Guest/CreateMembership', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          this.inquiry()
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    },
    onCheckInOut(row) {
      api.request('Account', 'get', '/api/Project/InquiryAll', null)
        .then(response => {
          var resData = response.data
          this.listProject = resData.entity
          window.$('#modal-checkinout').modal('show')
        })
      this.guestCheckInOut = {
        id: row.id,
        name: row.firstName + ' ' + row.lastName
      }
    },
    onContinueCheckInOut() {
      this.checkInOutProcess(this.guestCheckInOut, this.projectCheckInOut)
    },
    checkInOutProcess(guest, project) {
      var bSuccess = false
      var processType = ''
      var status = ''
      var message = ''
      if (!project.id || project.id === 0) {
        SweetAlert.fire('Check-In/Out Process', 'Please choose project', 'warning')
        return
      }

      var reqData = {
        GuestId: guest.id,
        ProjectId: project.id,
        ProjectName: project.name
      }
      api.request('Guest', 'post', '/api/Guest/CheckInOut', reqData)
        .then(response => {
          var resData = response.data
          bSuccess = resData.returnStatus
          processType = resData.entity.status
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          if (!bSuccess) {
            SweetAlert.fire('Check-In/Out Process', message, status)
          }
        })
        .then(reponse => {
          if (bSuccess) {
            if (processType === 'CheckIn') {
              this.onCheckInProcess(guest, project)
            } else if (processType === 'CheckOut') {
              this.onCheckOutProcess(guest, project)
            } else {
              status = 'error'
              message = 'Unknown status checkin or checkout'
              SweetAlert.fire('Check-In/Out Process', message, status)
            }
          }
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
          SweetAlert.fire('Check-In/Out Process', message, status)
        })
    },
    onCheckInProcess(guest, project) {
      // var me = this
      api.request('Guest', 'get', '/api/Guest/GetMembershipActive?GuestId=' + guest.id, null)
        .then(response => {
          var resData = response.data
          this.listGuestMembership = resData.entity

          // listGuestMembershipTemp.forEach(item => {
          //   if (item.projectId === project.id) {
          //     me.listGuestMembership.push(item)
          //   }
          // })
          window.$('#modal-checkin').modal('show')
        })
    },
    onContinueCheckIn() {
      var status = ''
      var message = ''

      var reqData = {
        GuestId: this.guestCheckInOut.id,
        ProjectId: this.projectCheckInOut.id,
        ProjectName: this.projectCheckInOut.text,
        MembershipId: this.guestMembershipCheckInOut.id
      }
      api.request('Guest', 'post', '/api/Guest/CheckInByAdmin', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          window.$('#modal-checkin').modal('hide')
          window.$('#modal-checkinout').modal('hide')
          SweetAlert.fire('CheckIn Process', message, status)
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
          SweetAlert.fire('CheckIn Process', message, status)
        })
    },
    onCheckOutProcess(guest, project) {
      api.request('Guest', 'get', '/api/Guest/GetMembershipActive?GuestId=' + guest.id, null)
        .then(response => {
          var resData = response.data
          this.listGuestMembership = resData.entity
          window.$('#modal-checkout').modal('show')
        })
    },
    onContinueCheckOut() {
      var status = ''
      var message = ''

      var reqData = {
        GuestId: this.guestCheckInOut.id,
        ProjectId: this.projectCheckInOut.id,
        ProjectName: this.projectCheckInOut.text,
        MembershipId: this.guestMembershipCheckInOut.id
      }
      api.request('Guest', 'post', '/api/Guest/CheckOut', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          window.$('#modal-checkin').modal('hide')
          window.$('#modal-checkout').modal('hide')
          SweetAlert.fire('CheckOut Process', message, status)
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
          SweetAlert.fire('CheckOut Process', message, status)
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  width: 250px;
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

.icheckbox_flat-green,
.iradio_flat-green {
    display: inline-block;
    *display: inline;
    vertical-align: middle;
    margin: 0;
    padding: 0;
    width: 20px;
    height: 20px;
    background: url('/static/img/green.png') no-repeat;
    border: none;
    cursor: pointer;
}

.icheckbox_flat-green {
    background-position: 0 0;
}
    .icheckbox_flat-green.checked {
        background-position: -22px 0;
    }
    .icheckbox_flat-green.disabled {
        background-position: -44px 0;
        cursor: default;
    }
    .icheckbox_flat-green.checked.disabled {
        background-position: -66px 0;
    }

.iradio_flat-green {
    background-position: -88px 0;
}
    .iradio_flat-green.checked {
        background-position: -110px 0;
    }
    .iradio_flat-green.disabled {
        background-position: -132px 0;
        cursor: default;
    }
    .iradio_flat-green.checked.disabled {
        background-position: -154px 0;
    }

.datetime-picker input {
  height: 34px !important;
}


.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Guest.vue?b062a6ae